/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */
import React, { useEffect, useRef, useState } from 'react'
import styles from './styles.module.scss'

const AttachementCard = ({ t, attach, dlAttachement, deleteAttachement }) => {
  const { fileName, url, date, path } = attach
  const [contextMenuData, setContextMenuData] = useState(null)
  const contextMenuRef = useRef()

  const handleClickOutside = (e) => {
    if (contextMenuRef.current && !contextMenuRef.current.contains(e.target)) {
      setContextMenuData(null)
    }
  }

  const toggleContextMenu = (e) => {
    e.preventDefault()
    handleClickOutside(e)
    setContextMenuData(true)
  }

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [contextMenuData])

  const contextMenuBtnAction = (action) => {
    switch (action) {
      case 'Download':
        dlAttachement(attach)
        break
      case 'Delete':
        deleteAttachement(attach)
        break
      default:
        break
    }
    setContextMenuData(null)
  }

  return (
    <li ref={contextMenuRef} key={path} className={styles.content_item} onContextMenu={(e) => toggleContextMenu(e)}>
      <img className={styles.attachment_img} src={url} alt='Patient' />
      {!contextMenuData ? (
        <div className={styles.attachment_info}>
          <span className={styles.attachment_name}>{fileName}</span>
          <span className={styles.attachment_date}>{date}</span>
        </div>
      ) : (
        <div className={styles.context_menu}>
          <button className={styles.attachment_context_menu_btn} onClick={() => contextMenuBtnAction('Download')}>
            {t('download')}
          </button>
          <button className={styles.attachment_context_menu_btn} onClick={() => contextMenuBtnAction('Delete')}>
            {t('delete')}
          </button>
        </div>
      )}
    </li>
  )
}
export default AttachementCard
